// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { ScanProxyApi } from '@digitalasset/validator-scan-proxy-api-ts-client';
import React, { useContext } from 'react';

export const ScanProxyApiContext = React.createContext<ScanProxyApi | undefined>(undefined);

export const useScanProxyApiClient: () => ScanProxyApi = () => {
  const client = useContext<ScanProxyApi | undefined>(ScanProxyApiContext);
  if (!client) {
    throw new Error('Validator scan proxy client not initialized');
  }
  return client;
};
